import { render, staticRenderFns } from "./ConcernsList.vue?vue&type=template&id=70a1b669&scoped=true&"
import script from "./ConcernsList.vue?vue&type=script&lang=js&"
export * from "./ConcernsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a1b669",
  null
  
)

export default component.exports